const MAINURL = 'https://us-central1-organify-72f15.cloudfunctions.net/zippiToolEndPoints-ZippiToolEndPoints';
//const MAINURL = 'https://us-central1-zippiplay-b7447.cloudfunctions.net/zippiToolEndPoints-ZippiToolEndPoints';

export default {

    fetchProjectData: async (toolId) => {
        try {
            const response = await fetch(`${MAINURL}?toolId=${toolId}`);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return await response.json();

        } catch (error) {
            console.log("ERROR ",error);
            return error;
        }
    },

    sendEmail: async (linkEmail, receipt, message) =>{
        try {
            const response = fetch(`${MAINURL}?linkEmail=${linkEmail}&receipt=${receipt}&message=${message}`)
            if (!response.ok) {
                console.log("RESPONSE ",await response);
                throw new Error("Network response was not ok");
            }
        } catch (error) {
            console.error("ERROR ",error);
            return error;
        }
    } 
}